import { useDispatch } from 'react-redux';

import type { AppDispatch } from '~features';

const useAppDispatch = () => useDispatch<AppDispatch>();

export default useAppDispatch;
